import { render, staticRenderFns } from "./AddNewLevel.vue?vue&type=template&id=c81ed85c&"
import script from "./AddNewLevel.vue?vue&type=script&lang=js&"
export * from "./AddNewLevel.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLevel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports